// extracted by mini-css-extract-plugin
export default {"root":"SignInHeader_root__U-FSn","title":"SignInHeader_title__fzhPP","back":"SignInHeader_back__9qOdI","info":"SignInHeader_info__T-yWq","endBtn":"SignInHeader_endBtn__-K8W0"};